import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "MagnifyingGlass",
  [
    [
      "path",
      {
        d: "M9.17651 2C5.31052 2 2.17651 5.13401 2.17651 9C2.17651 12.866 5.31052 16 9.17651 16C11.0625 16 12.7742 15.2542 14.0329 14.0414C14.0592 14.0072 14.0881 13.9742 14.1194 13.9429C14.1508 13.9115 14.1837 13.8827 14.2179 13.8564C15.4307 12.5977 16.1765 10.8859 16.1765 9C16.1765 5.13401 13.0425 2 9.17651 2ZM16.2084 14.6177C17.44 13.078 18.1765 11.125 18.1765 9C18.1765 4.02944 14.1471 0 9.17651 0C4.20595 0 0.176514 4.02944 0.176514 9C0.176514 13.9706 4.20595 18 9.17651 18C11.3015 18 13.2545 17.2635 14.7942 16.0319L18.4694 19.7071C18.8599 20.0976 19.4931 20.0976 19.8836 19.7071C20.2741 19.3166 20.2741 18.6834 19.8836 18.2929L16.2084 14.6177Z",
      },
    ],
  ],
  "currentColor"
);
